import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

// These Angular directives will act as an interface to the "upgraded" AngularJS directives (we did not use component in angularJS).
// Each Angular component (e.g. Ng1MessageDetailsReportComponentWrapperDirective) must be declared in the module
// where they are used (e.g. in missed-recall-report.module)

export const ENSURE_UPGRADED_DIRECTIVES_LOADED_EARLY = 'TT';

// tslint:disable-next-line:directive-selector
@Directive({selector: 'ng1-message-details-report'})
export class Ng1MessageDetailsReportComponentWrapperDirective extends UpgradeComponent {
    // The names of the input and output properties here must match the names of the
    // `<` and `&` bindings in the AngularJS component that is being wrapped.
    @Input() jobId !: String;

    constructor(elementRef: ElementRef, injector: Injector) {
        // We must pass the name of the directive as used by AngularJS to the super.
        super('messagingDetailsReport', elementRef, injector);
    }
}
